import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './http/api'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import * as echarts from 'echarts';
import VueCookies from 'vue-cookies';
import md5 from 'js-md5'
import { } from '@/utils/permissions/permissions.js'
import mixin from '@/components/mixin.js'

// import buyRobot from '@/components/buyRobot/buyRobot'

Vue.use(ElementUI);
Vue.use(VueCookies)

Vue.mixin(mixin)


Vue.config.productionTip = false
Vue.prototype.$api = api;


Vue.prototype.$echarts = echarts;
Vue.prototype.$md5 = md5
Vue.prototype.$http = ''

// Vue.component('buyRobot', buyRobot)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
